/**
  Author: Suneel Singh - suneel.singh@enabledata.com
  Purpose: Tenant Admin Report Results Component
  Date: Sept, 2020
**/

import React from 'react';
import {
  Link,
  makeStyles,
  Grid,
  Tooltip,
  IconButton,
  Typography,
  DialogActions,
  Button,
  DialogContent,
  Dialog,
} from '@material-ui/core';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import InfoIcon from '@material-ui/icons/Info';
// import BackButton from '@material-ui/icons/ArrowBack';
import { EmptyListingTable, EnhancedTable } from '../../components';
import { useStoreState, useStoreActions } from 'easy-peasy';
import { stringConstants } from '../../constants/stringConstants';import LocalStorageService from '../../services/localStorage';
import DisplayBreadcrumbs from '../../components/displayBreadcrumbs/displayBreadcrumbs';
const useStyles = makeStyles((theme) => ({
  exportButton: {
    padding: '6px 16px',
    textDecoration: 'none',
  },
  gridContainer: {
    padding: '20px 0 0',
  },
  formTopBar: {
    width: '100%',
    zIndex: '100',
    padding: '.5% 0px .5% .2%',
    backgroundColor: 'rgb(255, 255, 255)',
    boxShadow: 'rgba(0, 0, 0, 0.75) 0px 0px 9px 0px',
  },
}));

const CustomReportResult = (props) => {
  const classes = useStyles();
  const reportAction = useStoreActions((actions) => actions.report);
  const reportState = useStoreState((state) => state.report);
  const skipPageReset = false;
  const [customField, setCustomField] = React.useState({});
  const [nofound, setNofound] = React.useState(false);

  const [isOpen, setIsOpen] = React.useState(false);
  const [isProcessingStartedPopup, setIsProcessingStartedPopup] = React.useState(false);

  const [fileAlreadyRequested, setFileAlreadyRequested] = React.useState(false);
  const [fileAlreadyRequestedMsg, setFileAlreadyRequestedMsg] = React.useState('');

  const [fileProcessingMsg, setFileProcessingMsg] = React.useState('');

  const localStorageService = LocalStorageService.getService();

  const downloadReport = (event, reportId) => {
    event.preventDefault();
    reportAction.getReportFile(reportId).then(function (response) {
    }).catch(function (error) {      
      if(error.response.status === 434) {
        setFileAlreadyRequested(true);
        setFileAlreadyRequestedMsg(error.response.data.error);
      }
    });
  };  

  React.useEffect(() => {
    if(reportState.reportFileUrl?.data?.success) {
      localStorageService.setNotification(true);
      setFileProcessingMsg(reportState.reportFileUrl.data.data.message);
      setIsProcessingStartedPopup(true);
    }
  }, [reportState.reportFileUrl]);

  React.useEffect(() => {
    if(fileAlreadyRequested) {
      setIsOpen(true);
    }
  }, [fileAlreadyRequested, fileAlreadyRequestedMsg]);

  React.useEffect(() => {
    setIsProcessingStartedPopup(false);
    setFileAlreadyRequested(false);

    reportAction.getReportresultList(`${props.reportID}`)
      .then(function (response) {
        //console.log('response', response);
      })
      .catch(function (error) {
        console.log(error);
        setNofound(true);
      });
  }, []);

  React.useEffect(() => {
    if (reportState.reportresultList && reportState.reportresultList.tableHeaders) {
      let fields = reportState.reportresultList.tableHeaders.map((field, index) => {
        return {
          Header: reportState.reportresultList?.tableHeadersFormatted[index]?.replaceAll('_', ' '),
          accessor: field,
          Cell: ({ row }) => {
            return (
              <>
                {row.original[field]
                  ? (field==='PRIOR_AUTH_EXUMPTION'
                  || field==='CURRENT_STATUS'
                  || field==='POLICIES_CURRENT_STATUS'
                  || field==='PROCEDURES_CURRENT_STATUS'
                  || field==='INSTRUCTIONS_CURRENT_STATUS'
                  || field==='PROGRAMS_CURRENT_STATUS'
                  || field==='GROUPS_CURRENT_STATUS'
                  || field==='BUSINESSLINES_CURRENT_STATUS'
                  || field==='GROUPS_PRIOR_AUTH_EXUMPTION'
                  || field==='BUSINESSLINES_PRIOR_AUTH_EXUMPTION'?row.original[field].toLowerCase():row.original[field])
                  : ''}
              </>
            );
          },
          procedureClass: true
        };
      });
      setCustomField(fields);
      if (reportState.reportresultList.tableHeaders.length == 0) {
        setNofound(true);
      } else {
        setNofound(false);
      }
    }
  }, [reportState.reportresultList]);

  const handleClose = () => {
    setIsOpen(false);
    setFileAlreadyRequested(false);
  }

  const handleCloseProcessingPopup = () => {
    setIsProcessingStartedPopup(false);
  }

  return (
    <Grid container direction="row" style={{ backgroundColor: '#fff' }}>
      <Grid item md={12} xs={12}>            
        <DisplayBreadcrumbs items={[{title: 'Reports', link: '/reports/custom'}, { title: "Report Meta Fields", link: "/reports/"+props.reportID }, { title: "Report Preview", link: ""}]} />
      </Grid>
      {/* <Grid item md={12} className={`${classes.formTopBar}`}>
        <div style={{ display: 'flex' }}>
          <Tooltip title="Go Back">
            <IconButton
              color="primary"
              onClick={() => { reportAction.setCustomReport(null); props.history.push(`/reports/${props.reportID}`);}}
            >
              <BackButton fontSize="large" />
            </IconButton>
          </Tooltip>
          <Typography variant="h5" style={{ paddingTop: '13px' }}>
            <span style={{ fontSize: '20px' }}>Report</span>
          </Typography>
        </div>
      </Grid> */}
      {reportState.reportresultList && reportState.reportresultList.Items && customField && customField.length > 0 && (<Grid container direction="row">

        <Grid item md={12} className={classes.gridContainer}>
          <Grid container>
            <Grid item style={{padding: '10px', border: '2px solid rgb(105 133 216)', flex: 1, margin: '0 20px', borderRadius: '5px', borderColor: '#3358c6',lineHeight: '20px'}}>
              
              <InfoIcon style={{float: 'left',lineHeight: '20px', fontSize: '18px'}}></InfoIcon> &nbsp; Please click on the download icon to get a full report with all records
            </Grid>
          </Grid>
        </Grid>
        <Grid item md={12} className={classes.gridContainer}>
          <EnhancedTable
            paginationDefauldSize={50}
            columns={customField}
            data={reportState.reportresultList.Items}
            rowSelection={false}
            skipPageReset={skipPageReset}
            toolbar={{
              show: true,
              title: `Report Preview`,
              enableSearch: true,
              actionButtonGroup: (selected) => {
                return (
                  <div style={{ display: 'flex', width: '105px' }}>
                    <Link href={reportState.reportresultList && reportState.reportresultList.report_file} onClick={(event) => downloadReport(event, props.reportID)}>
                      <Tooltip title="Download Report">
                        <IconButton
                          color="primary"
                          aria-label="Download Report"
                        >
                          <CloudDownloadIcon />
                        </IconButton>
                      </Tooltip>
                    </Link>
                  </div>
                );
              },
            }}
          />
        </Grid>

        <Dialog
          disableBackdropClick
          disableEscapeKeyDown
          maxWidth="sm"
          aria-labelledby="confirmation-dialog-title"
          open={isOpen}
          PaperProps={{
            style: { borderRadius: 20 }
          }}
        >
          <DialogContent>
            <Grid>
              <Typography style={{paddingTop: '30px', paddingBottom: '30px', fontSize: '14px', textAlign: 'center'}}>{fileAlreadyRequestedMsg}</Typography>
            </Grid>
          </DialogContent>
          <DialogActions style={{padding: '0 35px 30px'}}>
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={2}
            >
              <Grid item>
                <Button
                  onClick={handleClose}
                  variant="contained"
                  color="secondary"
                >
                  Close
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>
        <Dialog
          disableBackdropClick
          disableEscapeKeyDown
          maxWidth="sm"
          aria-labelledby="confirmation-dialog-title"
          open={isProcessingStartedPopup}
          PaperProps={{
            style: { borderRadius: 20 }
          }}
        >
          <DialogContent>
            <Grid>
              <Typography style={{paddingTop: '30px', paddingBottom: '30px', fontSize: '14px', textAlign: 'center'}}> {fileProcessingMsg} </Typography>
            </Grid>
          </DialogContent>
          <DialogActions style={{padding: '0 35px 30px'}}>
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={2}
            >
              <Grid item>
                <Button
                  onClick={handleCloseProcessingPopup}
                  variant="contained"
                  color="secondary"
                >
                  Close
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>

        <Grid item md={12} className={classes.gridContainer}>
          <div
            style={{
              display: 'flex',
              textAlign: 'right',
              float: 'right',
              marginRight: '40px',
            }}
          >
            <Link href={reportState.reportresultList && reportState.reportresultList.report_file} onClick={(event) => downloadReport(event, props.reportID)}>
              <Tooltip title="Download Report">
                <IconButton
                  color="primary"
                  aria-label="Download Report"
                >
                  <CloudDownloadIcon />
                </IconButton>
              </Tooltip>
            </Link>
          </div>
        </Grid>
      </Grid>)}
      
      {nofound && (
        <Grid item md={12} >
          <div style={{ display: 'flex', margin: '40px' }}>
            <EmptyListingTable
              addPermition={true}
              propsHistory={props.history}
              addFormLink={`/reports/custom`}
              textMsg={stringConstants.noRecordFound}
              butnText={`Back to Reports`}
            /></div>
        </Grid>
      )}
      <style>
        {`
        .MuiTableCell-body{     text-transform: capitalize;}
      `}
      </style>
    </Grid>
  );
};

export default CustomReportResult;